const generateKey = (...args) => args.join(',')

const Units = {
  Pounds: 'lb(s)',
  Ounces: 'oz(s)',
  Kilograms: 'kg(s)'
}

const Ounces = 'Ounces'
const Pounds = 'Pounds'
const PoundsOunces = Pounds + Ounces

const FROM_OUNCES_TO_POUNDS_OUNCES = generateKey(Ounces, PoundsOunces)
const FROM_OUNCES_TO_POUNDS = generateKey(Ounces, Pounds)

export const WeightEnum = {
  Pounds,
  Ounces,
  PoundsOunces
}

const convertors = {
  [FROM_OUNCES_TO_POUNDS_OUNCES]: (val) => `${Math.floor(val / 16)} ${Units.Pounds}, ${val % 16} ${Units.Ounces}`,
  [FROM_OUNCES_TO_POUNDS]: (val) => `${(val / 16).toFixed(4)} ${Units.Pounds}`
}

export default {
  name: 'weight',
  filter: (value, from, to) => {
    const conversion = generateKey(from, to)
    if (Object.keys(convertors).includes(conversion)) {
      return convertors[conversion](value)
    } else {
      console.warn(`[WeightFilter]: does not support converting ${from} to ${to}.`)
      return value
    }
  }
}
